import React from 'react';
import { Link } from 'react-router-dom';

const STATUS_MESSAGES = {
  trial: 'Триальный период истек.',
  expired: 'Срок действия тарифа истек.',
  past_due: 'Тариф не оплачен.',
  cancelled: 'Подписка отменена.',
};

function SubscriptionRestrictionModal({ isOpen, status = '', onClose }) {
  if (!isOpen) return null;

  const statusMessage = STATUS_MESSAGES[status] || 'Подписка неактивна.';

  return (
    <div className="fixed inset-0 z-[1100] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-6 text-white">
          <h3 className="text-xl font-bold">Ограничение доступа</h3>
          <p className="mt-1 text-sm text-white/90">{statusMessage}</p>
        </div>

        <div className="p-6">
          <p className="text-gray-700">
            Тариф не оплачен или триальный период завершен. Функции системы ограничены, но вам доступен функционал
            истории и профиля.
          </p>

          <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
            <Link
              to="/ai-history"
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors"
              onClick={onClose}
            >
              История
            </Link>
            <Link
              to="/profile"
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors"
              onClick={onClose}
            >
              Профиль
            </Link>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-purple-600 text-white text-sm font-medium hover:bg-purple-700 transition-colors"
              onClick={onClose}
            >
              Тарифы
            </Link>
          </div>

          <div className="mt-5 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition-colors"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionRestrictionModal;
